import { Program, Slot } from '@/new-transport/_models/transport-map.model';

export const programFactory = (
	destinationId: number,
	destinationName: string,
	reservationMap: Map<number, Slot[]>,
	fromCity: number,
): Program => {
	return {
		destinationId: destinationId,
		destinationName: destinationName,
		reservation: reservationMap,
		optionParticipants: 0, // TODO: calculate it
		confirmedParticipants: 0,
		fromCity: fromCity,
	};
};
